'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import type { SliderProps as RadixSliderProps } from '@radix-ui/react-slider';
import * as RadixSlider from '@radix-ui/react-slider';
interface SliderProps extends RadixSliderProps {
  min: number;
  max: number;
  value: number[];
  /** @deprecated 값 위치 그라데이션 폭 — 표준 트랙으로 전환되어 더 이상 사용하지 않음 */
  range?: number;
  className?: string;
}
export const Slider = t0 => {
  const $ = _c(20);
  let ariaLabel;
  let className;
  let max;
  let min;
  let props;
  let value;
  if ($[0] !== t0) {
    const {
      className: t1,
      value: t2,
      min: t3,
      max: t4,
      range,
      "aria-label": t5,
      ...t6
    } = t0;
    className = t1;
    value = t2;
    min = t3;
    max = t4;
    ariaLabel = t5;
    props = t6;
    $[0] = t0;
    $[1] = ariaLabel;
    $[2] = className;
    $[3] = max;
    $[4] = min;
    $[5] = props;
    $[6] = value;
  } else {
    ariaLabel = $[1];
    className = $[2];
    max = $[3];
    min = $[4];
    props = $[5];
    value = $[6];
  }
  let t1;
  if ($[7] !== className) {
    t1 = cn("relative flex h-6 touch-none select-none items-center", className);
    $[7] = className;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <RadixSlider.Track className="relative h-6 grow cursor-pointer overflow-hidden rounded-pill bg-Gray-200"><RadixSlider.Range className="absolute h-full rounded-pill bg-B-400" /></RadixSlider.Track>;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("block size-24 rounded-pill border-4 border-B-300 bg-Gray-white", "cursor-pointer transition-colors duration-200 ease-in-out", "hover:border-B-500", "focus-visible:border-B-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-B-500");
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== ariaLabel) {
    t4 = <RadixSlider.Thumb aria-label={ariaLabel} className={t3} />;
    $[11] = ariaLabel;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== max || $[14] !== min || $[15] !== props || $[16] !== t1 || $[17] !== t4 || $[18] !== value) {
    t5 = <RadixSlider.Root max={max} min={min} value={value} {...props} className={t1}>{t2}{t4}</RadixSlider.Root>;
    $[13] = max;
    $[14] = min;
    $[15] = props;
    $[16] = t1;
    $[17] = t4;
    $[18] = value;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
};